export default "__VITE_ASSET__2158c098__"